module.exports = __webpack_public_path__ + "assets/24e3ab7ef5f7cbf96a02b295b86a0daa.mp4";